<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <b-card>
                <div class="d-flex align-items-center justify-content-between">
                    <h4 class="mb-0"><i class="fa fa-list mr-2" />Surat Perintah Kerja (Engine)</h4>
                    <div class="text-right">
                        <router-link v-if="isAddAllowed" to="/spk-engine/create">
                            <b-button variant="dark">
                                <i class="fa fa-plus mr-2" />SPK Baru
                            </b-button>
                        </router-link>
                    </div>
                </div>
                <hr />
                <b-row>
                    <b-col md="3">
                        <b-form-group label="No. SPK">
                            <b-form-input v-model="filter.no" type="search" @keydown.enter="getItems()" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="No. SN">
                            <b-form-input v-model="filter.sn" type="search" @keydown.enter="getItems()" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Status SPK">
                            <b-form-select v-model="filter.status" :options="optStatus">
                                <template v-slot:first>
                                    <b-form-select-option value=-1>Semua</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="3">
                        <b-form-group label="Dari Tanggal Pembuatan">
                            <b-form-input v-model="filter.start" type="date" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Sampai Tanggal Pembuatan">
                            <b-form-input v-model="filter.end" type="date" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Dari Tanggal Selesai">
                            <b-form-input v-model="filter.startFinish" type="date" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Sampai Tanggal Selesai">
                            <b-form-input v-model="filter.endFinish" type="date" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="BOM">
                            <b-form-select v-model="filter.bom">
                                <b-form-select-option value=-1>Semua</b-form-select-option>
                                <b-form-select-option value=1>Outstanding / Ready</b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="SPB">
                            <b-form-select v-model="filter.spb">
                                <b-form-select-option value=-1>Semua</b-form-select-option>
                                <b-form-select-option value=1>Outstanding</b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Alur Kerja">
                            <b-form-select v-model="filter.flow">
                                <b-form-select-option value=-1>Semua</b-form-select-option>
                                <b-form-select-option value=1>REPAIR</b-form-select-option>
                                <b-form-select-option value=2>SCRAP</b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Tipe Pengerjaan">
                            <b-form-select v-model="filter.operation">
                                <b-form-select-option value=-1>Semua</b-form-select-option>
                                <b-form-select-option value=1>REPAIR</b-form-select-option>
                                <b-form-select-option value=2>OVERHAUL</b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <div class="search-wrapper d-flex align-items-center mb-3">
                    <b-button variant="primary" class="mr-2" @click="getItems">
                        <i class="fa fa-search mr-2" /> Search
                    </b-button>
                    <b-button variant="danger" @click="resetSearch">
                        <i class="fa fa-times mr-2" /> Reset Search
                    </b-button>
                </div>
                <b-table bordered hover show-empty
                    :busy="isBusy"
                    :items="items"
                    :fields="fields"
                    responsive class="mb-3"
                >
                    <template v-slot:empty>
                        Tidak ada SPK.
                    </template>
                    <template v-slot:cell(no)="row">
                        {{ row.item.no }}
                        <div class="text-muted small font-weight-bold">
                            <span v-if="row.item.flow == 1">REPAIR</span>
                            <span v-else-if="row.item.flow == 2">SCRAP</span>
                            <span v-else>-</span>
                        </div>
                    </template>
                    <template v-slot:cell(operation)="row">
                        <span v-if="row.item.operation == 1">REPAIR</span>
                        <span v-else-if="row.item.operation == 2">OVERHAUL</span>
                        <span v-else>-</span>
                    </template>
                    <template v-slot:cell(status)="row">
                        <b-badge :variant="parseStatusBadge(row.item.status)">{{ row.item.status }}</b-badge>
                        <div v-if="row.item.bomOuts != 0" class="small font-weight-bold">
                            BOM: {{ row.item.bomOuts }} Outs. <span v-if="row.item.bomReady != 0">{{ row.item.bomReady }} Ready.</span>
                        </div>
                        <div v-for="spb in row.item.spb" v-bind:key="spb" class="text-muted small">
                            {{ spb }}
                        </div>
                    </template>
                    <template v-slot:cell(unit)="row">
                        {{ row.item.sn }}
                        <div class="small text-muted">{{ row.item.type }}</div>
                    </template>
                    <template v-slot:cell(createdAt)="row">
                        {{ $helper.parseDate(row.item.createdAt) }}
                        <div class="small text-muted">{{ $helper.parseHourMinute(row.item.createdAt) }}</div>
                    </template>
                    <template v-slot:cell(finishedAt)="row">
                        {{ $helper.parseDate(row.item.finishedAt) }}
                        <div class="small text-muted">{{ $helper.parseHourMinute(row.item.finishedAt) }}</div>
                    </template>
                    <template v-slot:cell(action)="row">
                        <router-link :to="'/spk-engine/' + row.item.id">
                            <b-button size="sm" variant="primary" v-b-tooltip.hover.top title="Detail">
                                <i class="fa fa-fw fa-search" />
                            </b-button>
                        </router-link>
                    </template>
                </b-table>
                <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                    <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" />
                    <b-pagination class="mb-0"
                        v-model="currentPage"
                        :totalRows="totalRows"
                        :per-page="perPage"
                        @change="onPageChange"
                    />
                </div>
            </b-card>
        </div>
    </div>
</template>

<script>
export default {
    name: 'spk-engine-list',
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            filter: {
                no: "",
                sn: "",
                status: -1,
                bom: -1,
                spb: -1,
                start: "",
                end: "",
                startFinish: "",
                endFinish: "",
                flow: -1,
                operation: -1
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "no", label: "No. SPK & Alur Kerja" },
                { key: "operation", label: "Tipe Pengerjaan" },
                { key: "unit", label: "Unit" },
                { key: "status", label: "Status / BOM / SPB" },
                { key: "createdAt", label: "Tanggal Pembuatan" },
                { key: "finishedAt", label: "Tanggal Selesai" },
                { key: "action", label: "Aksi"},
            ],

            items: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,

            optStatus: [
                { value: 1, text: "BARU" },
                { value: 2, text: "WAIT JOB DESC" },
                // { value: 3, text: "WAIT ACC BOM" },
                // { value: 4, text: "WAIT LOG" },
                { value: 5, text: "IN PROCESS" },
                { value: 6, text: "WAIT APPR" },
                { value: 7, text: "WAIT RETURN" },
                { value: 8, text: "CLOSED" },
                { value: 9, text: "WAIT SCRAP APPROVAL" },
                { value: 10, text: "WAIT SCRAP RECEIVED" },
                { value: 0, text: "BATAL" }
            ]

        }
    },
    computed: {

        isAddAllowed() {
            return [0, 8].includes(this.$helper.getRoleId())
        }

    },
    methods: {

        init() {

            this.initStatus = 0

            let getItems = this.getItems()

            Promise.all([getItems]).then(res => {
                this.initStatus = 1
            })
            .catch(error => {
                this.$helper.parseError(this, error)
                this.initStatus = -1
            })

        },

        getItems(page = 1) {

            let query = ""

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage - 1, this.perPage)

            if(!this.$helper.isBlank(this.filter.no)) {
                param += "&filterNo=" + this.filter.no
            }

            if(!this.$helper.isBlank(this.filter.sn)) {
                param += "&filterSn=" + this.filter.sn
            }

            if(this.filter.status != -1) {
                param += "&filterStatus=" + this.filter.status
            }

            if(!this.$helper.isBlank(this.filter.start)) {
                param += "&filterStart=" + this.filter.start
            }

            if(!this.$helper.isBlank(this.filter.end)) {
                param += "&filterEnd=" + this.filter.end
            }

            if(!this.$helper.isBlank(this.filter.startFinish)) {
                param += "&filterStartFinish=" + this.filter.startFinish
            }

            if(!this.$helper.isBlank(this.filter.endFinish)) {
                param += "&filterEndFinish=" + this.filter.endFinish
            }

            if(this.filter.bom == 1) {
                param += "&filterBom=true"
            }

            if(this.filter.spb == 1) {
                param += "&filterSpb=true"
            }

            if(this.filter.flow != -1) {
                param += "&filterFlow=" + this.filter.flow
            }

            if(this.filter.operation != -1) {
                param += "&filterOperation=" + this.filter.operation
            }

            // Execute
            return this.$axios.get("spk-engine/" + param).then(res => {

                this.items = res.data.data
                this.totalRows = res.data.total

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems()
        },

        onPageChange(newPage) {
            this.getItems(newPage)
        },

        resetSearch() {

            this.filter.no = ""
            this.filter.sn = ""
            this.filter.category = -1
            this.filter.status = -1
            this.filter.bom = -1
            this.filter.start = ""
            this.filter.end = ""
            this.getItems()

        },

        parseStatusBadge(status) {

            switch(status) {
                case "BATAL": return "danger"
                case "BARU": return "primary"
                case "CLOSED": return "success"
                case "IN PROCESS": return "warning"
                default: return "dark"
            }

        }

    },
    created() {
        this.init()
    }
}
</script>
